const bookReducer = (state = {}) => state;

export default bookReducer;
